import { render, staticRenderFns } from "./adjustOrderAdd.vue?vue&type=template&id=210c0c87&scoped=true"
import script from "./adjustOrderAdd.vue?vue&type=script&lang=js"
export * from "./adjustOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./adjustOrderAdd.vue?vue&type=style&index=0&id=210c0c87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c0c87",
  null
  
)

export default component.exports